/**
 * Paramètres d'un job du worker pipeline — constantes UI.
 *
 * ⚠️ Miroir de `supabase/functions/_shared/pipeline-job-params.ts`. Garder les
 * deux fichiers synchronisés : étapes, libellés, défauts, bornes.
 */

/** Étapes LLM exécutées par le worker `pipeline-process-job`. */
export type WorkerStep =
  | 'statement_generate'
  | 'statement_verify'
  | 'solution_generate'
  | 'solution_verify'
  | 'distractors_generate';

export const WORKER_STEPS: WorkerStep[] = [
  'statement_generate',
  'statement_verify',
  'solution_generate',
  'solution_verify',
  'distractors_generate',
];

/** Libellés lisibles des étapes du worker. */
export const WORKER_STEP_LABELS: Record<WorkerStep, string> = {
  statement_generate: 'Énoncé — génération',
  statement_verify: 'Énoncé — vérification',
  solution_generate: 'Corrigé — génération',
  solution_verify: 'Corrigé — vérification',
  distractors_generate: 'Distracteurs',
};

/** `max_tokens` par défaut de chaque étape du worker. */
export const DEFAULT_STEP_MAX_TOKENS: Record<WorkerStep, number> = {
  statement_generate: 8000,
  statement_verify: 4000,
  solution_generate: 6000,
  solution_verify: 4000,
  distractors_generate: 6000,
};

/** Bornes admissibles d'une surcharge `max_tokens`. */
export const MAX_TOKENS_MIN = 512;
export const MAX_TOKENS_CEILING = 32000;

/** Bornes admissibles d'une surcharge du nombre d'itérations. */
export const MAX_ITERATIONS_MIN = 1;
export const MAX_ITERATIONS_CEILING = 10;

/** Surcharges de relance manuelle d'un job. */
export interface JobRetryOverrides {
  maxTokens?: Partial<Record<WorkerStep, number>>;
  maxIterationsStatement?: number;
  maxIterationsSolution?: number;
}
